import React, { useState } from "react";
import { gql } from "graphql-tag";

import { useAction } from "hooks";
import { FolderInput, FileUploadsInput, BooleanInput, DateInput } from "inputs";
import { FormDialog } from "controls";
import { showMessage } from "helpers";
import dateToRevisionedAt from "helpers/dateToRevisionedAt";

export default React.memo(UploadFilesDialog);
function UploadFilesDialog({ folderId, onClose }) {
  const [overrideRevisionedDate, overrideRevisionedDateSet] = useState(false);

  const uploadFiles = useAction(gql`
    mutation UploadFilesDialog($input: UploadFilesInput!) {
      uploadFiles(input: $input) {
        folder {
          id
          items {
            id
          }
          files {
            id
          }
        }
      }
    }
  `);

  return (
    <FormDialog
      title="上传文档"
      onClose={onClose}
      fields={[
        {
          label: "位置",
          name: "folderId",
          value: folderId,
          inputComponent: FolderInput,
          required: true,
        },
        {
          label: "要上传的文档",
          name: "fileUploads",
          value: [],
          inputComponent: FileUploadsInput,
          required: true,
        },
        {
          label: "手动指定版本日期",
          inputComponent: BooleanInput,
          value: false,
          onChange: overrideRevisionedDateSet,
        },
        overrideRevisionedDate && {
          name: "revisionedDate",
          label: "版本日期",
          inputComponent: DateInput,
          value: new Date().toLocaleDateString("sv"),
          required: true,
        },
      ]}
      onSubmit={async (formData) => {
        const { folderId, fileUploads, revisionedDate } = formData;
        await uploadFiles({
          input: {
            folderId,
            fileUploads,
            ...(overrideRevisionedDate && revisionedDate
              ? { revisionedAt: dateToRevisionedAt(revisionedDate) }
              : {}),
          },
        });
        showMessage({ message: "成功上传文档" });
      }}
    />
  );
}
